import React from "react";
import {
  TextField,
  InputAdornment,
  IconButton
} from "@mui/material";
import { Search, Clear as ClearIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const SearchBar = ({ searchText, setSearchText, handleClear, onFocus }) => {
    const navigate=useNavigate()
      const globalSearchflag = (e) => {
    e.preventDefault();

    navigate("/globalsearch");
  };
  return (
    <TextField
     
      variant="outlined"
      fullWidth
      placeholder="Find items or machine"
      value={searchText}
      onClick={(e) => globalSearchflag(e)}
      sx={{
        backgroundColor: "#fff",
        borderRadius: "10px",
        boxShadow: "0px 1px 4px rgba(0, 0, 0, 0.08)",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#E0E0E0",
          },
          "&:hover fieldset": {
            borderColor: "#20C5CB",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#FE8B27",
            boxShadow: "0px 0px 4px rgba(254, 139, 39, 0.4)",
          },
          "& input": {
            fontSize: "15px",
            color: "rgba(56, 79, 111, 1)",
          },
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search sx={{ color: "#64748B" }} />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            {searchText && (
              <IconButton edge="end" onClick={handleClear}>
                <ClearIcon />
              </IconButton>
            )}
          </InputAdornment>
        ),
      }}
      InputLabelProps={{
        shrink: true,
      }}
    />
  );
};


export default SearchBar;
